export default __webpack_public_path__ + "static/media/luv4.4a00ef8e.mp3";